module.exports = __webpack_public_path__ + "img/组 127@2x.87972a84.png";